
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[site]/publications",
      function () {
        return require("private-next-pages/_sites/[site]/publications/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_sites/[site]/publications"])
      });
    }
  